import TeacherToolsQuotaProvider from 'core/chatbot/contexts/AIChatQuota/TeacherToolsQuotaProvider';
import useIsAIQuotaExhausted from 'core/chatbot/hooks/useIsAIQuotaExhausted';
import Button from 'ui/atoms/Button/Button';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

function DialogSelectTypeEvaluationButtons({ t, onSelectEvaluationManual, onSelectEvaluationAI }) {
  const isQuotaExhausted = useIsAIQuotaExhausted();

  return (
    <div className="dialog-select-type-evaluation__buttons">
      <Button
        text={t('course:Manually generated')}
        onClick={onSelectEvaluationManual}
        variant="primary-outline"
        className="dialog-select-type-evaluation__button"
      />
      <Button
        text={t('course:AI generated')}
        onClick={onSelectEvaluationAI}
        variant="primary-outline"
        rightIcon="ai"
        className="dialog-select-type-evaluation__button"
        isDisabled={isQuotaExhausted}
      />
    </div>
  );
}

DialogSelectTypeEvaluationButtons.propTypes = {
  onSelectEvaluationManual: PropTypes.func.isRequired,
  onSelectEvaluationAI: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const DialogSelectTypeEvaluation = ({ t, open = false, onClose = () => {}, onSelectEvaluationManual = () => {}, onSelectEvaluationAI = () => {} }) => {
  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      title={t('course:How do you want the quiz to be?')}
      className="dialog-select-type-evaluation"
      size="m"
    >
      <div className="dialog-select-type-evaluation__content">
        <TeacherToolsQuotaProvider>
          <DialogSelectTypeEvaluationButtons t={t} onSelectEvaluationManual={onSelectEvaluationManual} onSelectEvaluationAI={onSelectEvaluationAI} />
        </TeacherToolsQuotaProvider>
      </div>
    </Dialog>
  );
};

DialogSelectTypeEvaluation.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSelectEvaluationManual: PropTypes.func,
  onSelectEvaluationAI: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation(['course', 'actions', 'common'])(DialogSelectTypeEvaluation);
